import Layout from "../components/layout/Layout";
import Users from "../components/page/Users";

const UsersPage = () => {
  return (
    <Layout>
      <Users />
    </Layout>
  );
};
export default UsersPage;
